import get from 'lodash/get'
import * as Sentry from '@sentry/browser'

// Requests
import {
  getFavoriteListings,
  postToggleFavoriteListing,
} from 'src/api/nestready/requests'

// Constants
import { LISTINGS_FAVORITES } from 'src/constants/listings'
import {
  TOGGLE_FAVORITE_LISTING,
  FETCH_HOMEBOT_LISTINGS_REQUEST,
  FETCH_HOMEBOT_LISTINGS_SUCCESS,
  FETCH_HOMEBOT_LISTINGS_FAILURE,
} from './actionTypes'

export const fetchFavoriteListings = customerId => dispatch => {
  const tag = LISTINGS_FAVORITES
  dispatch({ type: FETCH_HOMEBOT_LISTINGS_REQUEST, page: 1, tag })

  getFavoriteListings(customerId)
    .then(resp => {
      const listings = get(resp, 'data.data', [])
      dispatch({
        type: FETCH_HOMEBOT_LISTINGS_SUCCESS,
        page: 1,
        listings,
        tag,
      })
    })
    .catch(error => {
      dispatch({
        type: FETCH_HOMEBOT_LISTINGS_FAILURE,
        tag,
      })
      Sentry.captureException(error)
    })
}

export const setFavoriteListing = ({
  listing,
  isFavorited,
  tag,
  position,
}) => ({
  type: TOGGLE_FAVORITE_LISTING,
  listing,
  isFavorited,
  tag,
  position,
})

export const toggleFavoriteListing =
  ({ listing, customerId, position }) =>
  dispatch => {
    postToggleFavoriteListing(listing, customerId)
      .then(resp => {
        const response = get(resp, 'data.data')
        dispatch(
          setFavoriteListing({
            listing,
            isFavorited: response.isFavorited,
            position,
            tag: LISTINGS_FAVORITES,
          })
        )
      })
      .catch(error => {
        Sentry.captureException(error)
      })
  }
